module.exports = __webpack_public_path__ + "static/media/phone.695bd90a.svg";